// Moglee Base — hero slideshow: arrows, optional autoplay, pause on hover.

(function () {
  document.querySelectorAll('[data-mb-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-mb-hero-track]');
    if (!track) return;

    var slides = track.children.length;
    if (slides < 2) return;

    var interval = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;

    function go(direction) {
      var width = track.clientWidth;
      var next = track.scrollLeft + direction * width;
      if (next > track.scrollWidth - width - 5) next = 0;
      if (next < 0) next = (slides - 1) * width;
      track.scrollTo({ left: next, behavior: 'smooth' });
    }

    hero.querySelectorAll('[data-mb-hero-prev]').forEach(function (button) {
      button.addEventListener('click', function () {
        go(-1);
      });
    });

    hero.querySelectorAll('[data-mb-hero-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        go(1);
      });
    });

    function start() {
      if (!interval) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = window.setInterval(function () {
        go(1);
      }, interval * 1000);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    start();
  });
})();
